import React, { useEffect } from "react";
import '../header/Header.css';
import { AiFillHome } from "react-icons/ai";
import { IoPersonSharp } from "react-icons/io5";
import { IoCodeWorkingSharp } from "react-icons/io5";
import { BsPersonWorkspace } from "react-icons/bs";
import { Link } from 'react-router-dom';



function Header(){

  useEffect (() => {
   const h1element = document.querySelectorAll('.link h1');
   h1element.forEach(element => {
    element.addEventListener('click' , () => {
      h1element.forEach(el => {
        el.classList.remove('active');
      })
      element.classList.add('active');
    })
   })

   
  }, []);

    return(
        <>
        <div className="header flex justify-between backdrop-blur-xl text-[#4db5ff] text-xl p-5">
          <div className="logo flex justify-between items-center">
            <h1 className="">ELBASTAWESY</h1>
          </div>
          <div className="link headings flex justify-between">
            <Link to={'/'}><h1>Home</h1></Link>
            <Link to={'/about'}><h1>About</h1></Link>
            <Link to={'/experience'}><h1>Experience</h1></Link>
            <Link to={'/portfolio'}><h1>Portfolio</h1></Link>
          </div>
          <div className="link icons flex justify-between">
          <Link to={'/'}>
            <AiFillHome className="m-2"/>
          </Link>
          <Link to={'/about'}>
            <IoPersonSharp className="m-2"/>
          </Link>
          <Link to={'/experience'}>
            <IoCodeWorkingSharp className="m-2"/>
          </Link>
          <Link to={'/portfolio'}>
            <BsPersonWorkspace className="m-2"/>
          </Link>
          </div>
        </div>
        </>
    )
}

export default Header;

